import { render, staticRenderFns } from "./NeoparentShadowTags.vue?vue&type=template&id=12b14bb3&scoped=true"
import script from "./NeoparentShadowTags.vue?vue&type=script&lang=js"
export * from "./NeoparentShadowTags.vue?vue&type=script&lang=js"
import style0 from "./NeoparentShadowTags.vue?vue&type=style&index=0&id=12b14bb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b14bb3",
  null
  
)

export default component.exports